import { render, staticRenderFns } from "./PostCategoryPicker.vue?vue&type=template&id=60527518&"
import script from "./PostCategoryPicker.vue?vue&type=script&lang=js&"
export * from "./PostCategoryPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports